var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphicLockLight255(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 255,
    viewBox: "0 0 255 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_1525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.5 212.495C174.441 212.495 212.495 174.441 212.495 127.5C212.495 80.5588 174.441 42.5053 127.5 42.5053C80.5588 42.5053 42.5054 80.5588 42.5054 127.5C42.5054 174.441 80.5588 212.495 127.5 212.495Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.687 33.6241L61.8029 42.2782C61.9304 42.4854 61.771 42.7563 61.532 42.7563H51.316C51.077 42.7563 50.9176 42.4854 51.0451 42.2782L56.161 33.6241C56.2885 33.417 56.5913 33.417 56.7029 33.6241H56.687Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.812,
    cy: 84.4688,
    r: 37.25,
    fill: "#F2F2F2",
    stroke: "#B3B3B3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.532 175.376C232.19 175.376 234.345 173.221 234.345 170.563C234.345 167.905 232.19 165.75 229.532 165.75C226.874 165.75 224.719 167.905 224.719 170.563C224.719 173.221 226.874 175.376 229.532 175.376Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.651 90.27C120.133 90.27 122.145 88.2578 122.145 85.7756C122.145 83.2934 120.133 81.2812 117.651 81.2812C115.168 81.2812 113.156 83.2934 113.156 85.7756C113.156 88.2578 115.168 90.27 117.651 90.27Z",
    stroke: "#B3B3B3",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.457 178.5L145.462 186.963H135.469L140.473 178.5H140.457Z",
    stroke: "#B3B3B3",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.743 137.286H172.332V133.875C172.332 132.998 171.615 132.281 170.738 132.281C169.862 132.281 169.145 132.998 169.145 133.875V137.286H165.75C164.873 137.286 164.156 138.003 164.156 138.879C164.156 139.756 164.873 140.473 165.75 140.473H169.161V143.884C169.161 144.76 169.878 145.477 170.754 145.477C171.631 145.477 172.348 144.76 172.348 143.884V140.473H175.759C176.635 140.473 177.352 139.756 177.352 138.879C177.352 138.003 176.635 137.286 175.759 137.286H175.743Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.021 84.8517L190.381 98.935L184.875 95.8723L194.098 84.4678L184.875 73.0284L190.381 69.9656L202.021 83.9791V84.8604V84.8517ZM216.75 84.8517L205.18 98.935L199.674 95.8723L208.897 84.4678L199.674 73.0284L205.18 69.9656L216.75 83.9791V84.8604V84.8517Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7123 161.574V165.383C89.7123 171.519 84.7398 176.492 78.588 176.492H21.0536C14.9176 176.492 9.9292 171.519 9.9292 165.383V130.05C9.9292 123.914 12.3995 118.926 18.5514 118.926H78.588C84.7239 118.926 89.7123 123.898 89.7123 130.05V134.831M24.2729 118.942V113.284C24.2729 99.2428 35.7001 87.8316 49.7251 87.8316C63.7501 87.8316 75.1773 99.2588 75.1773 113.284V118.942M67.1767 119.005V113.3C67.1767 103.673 59.3514 95.8481 49.7251 95.8481C40.0989 95.8481 32.2736 103.673 32.2736 113.3V118.958",
    stroke: "#B3B3B3",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5356 227.906V237.899M78.54 232.911H68.5312",
    stroke: "#B3B3B3",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7055 142.338C56.7374 138.465 53.6455 135.309 49.7727 135.278C45.8999 135.246 42.7443 138.338 42.7124 142.21C42.7124 142.258 42.7124 142.306 42.7124 142.354C42.7443 144.585 43.844 146.657 45.6927 147.932V155.853C45.5812 158.18 47.3662 160.14 49.6771 160.268C52.004 160.379 53.9643 158.594 54.0918 156.283C54.0918 156.14 54.0918 155.996 54.0918 155.853V147.693C55.7333 146.402 56.6896 144.442 56.7215 142.354L56.7055 142.338Z",
    stroke: "#0078D7",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1867 140.585C97.9198 138.098 99.2586 135.756 101.219 133.779C107.466 127.532 117.587 127.532 123.834 133.779C130.082 140.027 130.082 150.147 123.834 156.395C117.587 162.642 107.466 162.642 101.219 156.395C99.1789 154.355 97.8083 151.884 97.107 149.271L95.322 149.111L89.2976 154.944L85.7276 149.972H82.8111L77.9501 154.689L68.5311 145.27L73.2326 140.569H97.1867V140.585Z",
    stroke: "#0078D7",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.858 148.537C119.759 148.537 121.3 146.996 121.3 145.095C121.3 143.194 119.759 141.652 117.858 141.652C115.956 141.652 114.415 143.194 114.415 145.095C114.415 146.996 115.956 148.537 117.858 148.537Z",
    stroke: "#0078D7",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_1525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 255,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicLockLight255);
export default __webpack_public_path__ + "static/media/graphic_lock-light-255.e3ab64123d64444e1cf58d4726648a46.svg";
export { ForwardRef as ReactComponent };